import GdModalConfirm from "@/components/GdModalConfirm";
import HBIcon from "@/components/HBIcon";
import HBMessage from "@/components/HBMessage";
import { openUdesk } from "@/utils/initUdesk";
import safeRedirectUrl from "@/utils/safeRedirectUrl";
import Router from "next/router";
import { ERROR_MAP, gaodingEditUrl } from "../shared";
import styles from "./index.module.less";

export const showErrorMessage = (result) => {
  if (result?.data?.code === ERROR_MAP.HB_USER_IS_MERGE_ERROR) {
    GdModalConfirm.open({
      closable: false,
      className: styles.confirm,
      hideOkButton: true,
      cancelText: "知道了",
      content: (
        <div className={styles.content}>
          <HBIcon className={styles.icon} type="ic_Warning" />
          <div className={styles.text}>
            该账号已合并其他稿定账号，请用其他花瓣账号登录。
          </div>
        </div>
      ),
    });
  } else if (result?.data?.code === ERROR_MAP.GD_USER_IS_MERGE_ERROR) {
    GdModalConfirm.open({
      closable: false,
      className: styles.confirm,
      hideOkButton: true,
      cancelText: "知道了",
      content: (
        <div className={styles.content}>
          <HBIcon className={styles.icon} type="ic_Warning" />
          <div className={styles.text}>
            该账号已合并其他花瓣账号，请用其他稿定账号登录。
          </div>
        </div>
      ),
    });
  } else if (result?.data?.code === ERROR_MAP.USER_IS_OLD_PERSONAL_ERROR) {
    GdModalConfirm.open({
      closable: false,
      className: styles.confirm,
      cancelText: "知道了",
      okText: "联系客服",
      content: (
        <div className={styles.content}>
          <HBIcon className={styles.icon} type="ic_Warning" />
          <div className={styles.text}>
            该账号需要升级后才可合并，请联系客服处理
          </div>
        </div>
      ),
      onOk: () => {
        openUdesk();
      },
    });
  } else {
    HBMessage.error(result?.data?.message || "");
  }
};

export function showMergeDone(redirect) {
  GdModalConfirm.open({
    closable: false,
    className: styles.success,
    hideCancelButton: true,
    okText: "开始使用",
    content: (
      <div className={styles.content}>
        <HBIcon className={styles.icon} type="ic_check_circle" />
        <div className={styles.text}>该账号已完成升级，可直接开始使用。</div>
      </div>
    ),
    onOk: () => {
      safeRedirectUrl(redirect || gaodingEditUrl);
    },
    onCancel: () => {
      safeRedirectUrl(redirect || gaodingEditUrl);
    },
  });
}

export enum PreCheckCode {
  bigCompany,
  unpayOrder,
}

export function showPreCheckMessage(code) {
  if (code === PreCheckCode.bigCompany) {
    GdModalConfirm.open({
      closable: false,
      className: styles.confirm,
      cancelText: "知道了",
      okText: "联系客服",
      onOk() {
        openUdesk();
      },
      content: (
        <div className={styles.content}>
          <HBIcon className={styles.icon} type="ic_Warning" />
          <div className={styles.text}>
            您是花瓣大企业会员，无法直接升级账号，请联系售后人员为您处理。
          </div>
        </div>
      ),
    });
  } else if (code === PreCheckCode.unpayOrder) {
    GdModalConfirm.open({
      closable: false,
      className: styles.confirm,
      hideCancelButton: true,
      okText: "我知道了",
      onOk() {
        Router.push("/me/order");
      },
      content: (
        <div className={styles.content}>
          <HBIcon className={styles.icon} type="ic_Warning" />
          <div className={styles.text}>
            您的花瓣账号有待支付的订单，暂时无法升级账号，请先完成或取消订单。
          </div>
        </div>
      ),
    });
  }
}
